import React from 'react';

// ** Components
import { Form, InputText, Textarea } from 'components';

// ** Styles
import { Inner, JoinUsStyled, StyledTitle } from './join-us.styled';

export const JoinUs = () => {
  // TODO: add submit logic here

  return (
    <JoinUsStyled>
      <Inner>
        <StyledTitle variant="h2" typographyType="h1">
          WANT TO JOIN FORCES?
        </StyledTitle>
        <Form submitButtonProps={{ text: 'SUBMIT' }}>
          <InputText placeholder="FIRST NAME" />
          <InputText placeholder="LAST NAME" />
          <Textarea placeholder="MESSAGE" />
        </Form>
      </Inner>
    </JoinUsStyled>
  );
};
